export default __webpack_public_path__ + "static/media/dojo-touch.614c93e0.png";